import http from '../prototypes/modules/http.js';
/**
 * 图片格式化
 */
export default {
  /**
   * 本地图片格式化
   */
  path(path) {
    return require('@/assets/images/' + path);
  },
  /**
   * 网络图片格式化
   */
  url(url) {
    return http.image + url;
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/filters/imageFormat.js